import * as types from '../actions/action-types';

export function reviews(state = {all: {}}, action) {
  switch (action.type) {
    case types.REQUEST_ALL_REVIEWS:
      return {...state, isFetchingAll: true};
    case types.RECEIVE_ALL_REVIEWS:
      return {...state, all: action.items, isFetchingAll: false, receivedAllAt: action.receivedAt};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/reviews.js